<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <referral-table></referral-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import referralTable from './ReferralTable.vue'

  export default {
    name: 'referral-table-view',
    components: {referralTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/referral/Referral.vue